:host {
  --ch-virtual-scroll__scroll-start-size: 0px;
  --ch-virtual-scroll__scroll-end-size: 0px;
  --ch-virtual-scroll__scroll-end-reserved-size: 0px;
  --ch-virtual-scroll__scroll-start-display: none;
  --ch-virtual-scroll__scroll-end-display: none;
  display: grid;
  grid-auto-rows: max-content;
}

:host(.ch-virtual-scroller--content-not-loaded) {
  opacity: 0;
  pointer-events: none;
}

:host(.ch-virtual-scroller--content-loaded) ::slotted(ch-smart-grid-cell:not([data-did-load])) {
  position: absolute;
  pointer-events: none;
  visibility: hidden;
}

:host(.ch-virtual-scroller--virtual-scroll)::before {
  content: "";
  display: var(--ch-virtual-scroll__scroll-start-display);
  block-size: var(--ch-virtual-scroll__scroll-start-size);
  inline-size: 0px;
  pointer-events: none;
}
:host(.ch-virtual-scroller--virtual-scroll)::after {
  content: "";
  display: var(--ch-virtual-scroll__scroll-end-display);
  block-size: calc(var(--ch-virtual-scroll__scroll-end-size) + var(--ch-virtual-scroll__scroll-end-reserved-size));
  inline-size: 2px;
  pointer-events: none;
  background-color: red;
}